module.exports = __webpack_public_path__ + "static/img/logo-brand.b4133d9.jpg";